const BannerData = {
  // videoUrl:
  //   "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Syros%2FNew%20Kia%20Syros%20SUV.mp4?alt=media&token=a0de9b7a-a956-4828-957e-c4b2dcc64e35",
  mobileImageUrl:"https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Syros%2Fbanner%2Fsyros_m.webp?alt=media&token=97df5d1d-a626-49d7-9210-38842d88b824",
   imageUrl:"https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2FSyros_d_1.mp4?alt=media&token=7fa80be0-b610-4eab-b80c-b87916c88c66",
  title: "Kia Syros",
  subtitle: "Evolved by the future.",
  price: "₹ 8 67 053*",
  features: [
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Syros%2FADAS_1.png?alt=media&token=6e292831-22ac-478a-8326-71669d08cb71",
      text: "ADAS Level 2 with 16 Autonomous Safety Features",
    },
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Syros%2FSunroof_1.png?alt=media&token=5f73875d-7059-4a26-8f96-3ce75dcbee25",
      text: "Dual Pane Panoramic Sunroof",
    },
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Syros%2FOTA_1.png?alt=media&token=ebdf3761-048a-4a53-99b9-a4e56a687539",
      text: "OTA Software Updates with Kia Remote Diagnostics",
    },
  ],
};

const IntroData = {
  heading: "Introducing, The Kia Syros.",
  subheading: "DRIVEN BY THE FUTURE.",
  description:
    "The Kia Syros isn’t merely an evolution; it’s a revolutionary leap in SUV design. With every curve, every angle, and every feature, it embodies the bold new Kia design language. More than just an SUV, it’s a movement, shaped to be as forward-thinking as the future it’s destined for. From its sleek and groundbreaking exterior to the cutting-edge technology inside, the Syros is crafted to inspire and lead, redefining what a new generation of SUVs should be.",
  image:
    "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2FB-NCAP.webp?alt=media&token=ef6f0ef0-28b7-4332-af80-1e6e8d913ac8",
};

const CarouselData = [
  {
    sub: "EXTERIOR",
    title: "A new era of SUV design.",
    data: "The Kia Syros is a bold reinvention in the SUV world. With its strong, upright stance and high squared shoulders, it commands attention at first glance. The chiselled bonnet and futuristic LED headlamps with DRLs not only highlight its power but also embody the cutting-edge design language Kia embraces for the future. This isn’t just a vehicle; it’s a statement of progress, where every detail is purposefully designed to lead the way in innovation and style.",
    carData: [
      {
        title: "Ice Cube MFR LED Headlamps with Starmap LED DRLs",
        description:
          "Precision lighting that blends a futuristic vision with striking style.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fsy1.webp?alt=media&token=5ad948ea-c3e8-4e1d-bcb4-42771326100b",
      },
      {
        title: "Starmap LED Tail Lamps",
        description:
          "A signature look that lights the way, leaving an indelible impression.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fsy2.webp?alt=media&token=9a3156d5-9d99-4f58-b1e9-8da1546fba87",
      },
      {
        title: "Streamline Door Handles",
        description:
          "A first-in-segment touch of the future, making access as smooth as the design.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fsy3.webp?alt=media&token=ef754c63-e21a-4f0b-b0d3-14230a66eff1",
      },
      {
        title: "R17 - 43.66cm (17”) Crystal Cut Alloy Wheels",
        description:
          "Turning heads and tackling terrain, with wheels that stand tall.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fsy4.webp?alt=media&token=f2243b87-0aec-4a1c-b79a-7973bcb0c8c8",
      },
      {
        title: "Kia Signature Digital Tiger Face",
        description:
          "A bold statement of otherworldly presence that mesmerizes.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fsy5.webp?alt=media&token=7209b324-c356-4e6c-b9e4-8aea3f332a3a",
      },
      {
        title: "Shark Finn Antenna and Integrated Spoiler",
        description:
          "Designed for seamless flow, combining style with enhanced connectivity.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Syros%2FEx-7.jpg?alt=media&token=1ac5d48f-6c1f-4006-893a-9f2d2409acad",
      },
      {
        title: "Robust Front & Rear Skid Plate with Silver Metallic Finish",
        description:
          "Rugged protection that perfectly complements the refined, future-ready design.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Syros%2FEx-8.jpg?alt=media&token=05061cfa-3474-4a22-8df4-c4a3f494f616",
      },
    ],
  },
  {
    sub: "INTERIOR",
    title: "Every detail speaks the language of tomorrow.",
    data: "The Kia Syros is a groundbreaking evolution, crafted to redefine the driving experience. With a low-floor design paired with high ground clearance, it offers a dynamic blend of comfort and performance. Inside, the Trinity Panoramic Display, advanced materials, and futuristic textures set the tone for innovation that makes this new species of SUV stand out from the crowd.",
    carData: [
      {
        title: "Dual Pane Panoramic Sunroof",
        description:
          "Expands your world with a view that bridges the present and the possibilities ahead.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fin1.webp?alt=media&token=da2deb10-8e33-407a-9fd1-ffe5bc22721a",
      },
      {
        title: "Electric Parking Brake with Auto Hold",
        description:
          "It holds the brake in place, giving you complete control at every stop.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fin2.webp?alt=media&token=baf0d234-9694-43d2-aad2-ee1f49d7ff64",
      },
      {
        title: "76.2cm (30”) Trinity Panoramic Display panel",
        description:
          "Navigate, control, and entertain seamlessly as you embrace the future of driving.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fin3.mp4?alt=media&token=aea829bb-2c0f-4837-a94b-419767a2c26c",
      },
      {
        title: "Harman Kardon Premium 8 Speakers Sound System",
        description:
          "Experience sounds like never before, with unparalleled precision and depth.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fin4.webp?alt=media&token=da02445a-cf0d-41dd-b536-decca1c05abf",
      },
      {
        title:
          "Second Row Seat Recline & Slide with Seat Ventilation Cushion (Seat only)",
        description:
          "First-in-segment innovation, designed to deliver unmatched comfort for every journey.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fin5.webp?alt=media&token=54712b88-9f00-4efa-9c68-411b9293b774",
      },
      {
        title: "64 Colour Ambient Mood Lighting",
        description:
          "Illuminates the cabin with a mood that evolves with you, from night to day.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Syros%2FInt-5.mp4?alt=media&token=185ba2a2-36a7-473a-b564-434a1ebcbd39",
      },
    ],
  },
  {
    sub: "PERFORMANCE",
    title: "A powerful new Species.",
    data: "Engineered for those who seek a driving experience that moves beyond the ordinary, the Syros combines cutting-edge performance and advanced technology, creating an evolution in motion that redefines what it means to drive into the future.",
    carData: [
      {
        title: "High-performance D1.5 CRDi VGT Diesel Engine",
        description:
          "With 116 PS of power and 250 Nm of torque, the 1.5 CRDi VGT Diesel Engine is built for both strength and efficiency. A smooth ride with maximum performance on every terrain.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fp1.webp?alt=media&token=ea2596d6-9657-41a7-88bd-fc083c240433",
      },
      {
        title: "Dynamic Smartstream G1.0 T-GDi Petrol Engine",
        description:
          "The 1.0 T-GDi Petrol Engine, with 120 PS of power and 172 Nm of torque, combines responsive acceleration with exceptional fuel efficiency—perfectly tuned for the future of driving.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fp2.webp?alt=media&token=580cad90-62b3-4e07-9a64-a5880813277f",
      },
    ],
  },
  {
    sub: "ENGINEERED FOR PEACE OF MIND",
    title: "The Evolution of Confidence.",
    data: "Empowering every journey with a seamless blend of advanced technology and thoughtful design, the Syros is built for those who seek to move ahead with assurance. With 20 robust standard safety pack integrated into the new species of SUV, it’s ready to keep you and your loved ones secure at every turn.",
    carData: [
      {
        title: "6 Airbags as Standard",
        description: "Guarding you with six points of defense, always.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Feng1.webp?alt=media&token=f8efb987-b643-4757-904f-ae6cdd002d9d",
      },
      {
        title: "Front and Rear Parking Sensors",
        description:
          "4 parking sensors each at the front and rear that guides you into the tightest spots.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Feng2.webp?alt=media&token=a4016752-7cb7-477f-9672-dd677bfcba2b",
      },
      {
        title: "ESS (Emergency Stop Signal)",
        description:
          "Ensures you're visible to others when you need to stop fast.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Feng3.webp?alt=media&token=80b1e037-7c6e-40a1-be05-e1d0805ebdfc",
      },
      {
        title: "Highline Tyre Pressure Monitor",
        description: "Monitors your tyre pressure for a smoother, safer drive.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Feng4.webp?alt=media&token=d9237564-6c87-4fdf-9d84-e9bb71e56c6b",
      },
      {
        title: "Front and Rear All Seat 3-Point Seatbelts with Reminder",
        description:
          "Reminds you to buckle up, keeping everyone safe on every trip.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Feng5.webp?alt=media&token=2af7edf7-122d-4c46-9a84-6ea5467a5724",
      },
    ],
  },
  {
    sub: "INTUITIVE ADAS LEVEL 2",
    title: "Next-gen intelligence, evolving your drive.",
    data: "With 16 autonomous features at your fingertips, ADAS Level 2 brings the future to your present. Experience enhanced control, unmatched precision, and a drive that adapts to you, effortlessly navigating through every road with intelligent safety features that ensure peace of mind at every turn.",
    carData: [
      {
        title: "Smart Cruise Control with Stop & Go (SSC w/ S&G)",
        description:
          "Automatically maintains distance and manages stop-and-go traffic.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fintu1.mp4?alt=media&token=8b4d8768-5ce6-43f3-8a2d-31a733d77685",
      },
      {
        title: "Front Collision Warning (FCW)",
        description: "Notifies you when there’s a risk of a front collision.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fintu2.mp4?alt=media&token=093d9b91-7c27-4878-a086-0aa57827686c",
      },
      {
        title: "Front Collision-Avoidance Assist - Car (FCA – Car)",
        description:
          "Helps prevent accidents by alerting you of cars on your path.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fintu3.webp?alt=media&token=214776c5-e083-4e7d-95a4-70a414fb7853",
      },
      {
        title: "Front Collision - Avoidance Assist - Cycle (FCA - Cyclist)",
        description: "Detects cyclists ahead and helps prevent collisions.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fintu4.mp4?alt=media&token=072646e0-40e0-4ea6-9247-6ef8910023cc",
      },
      {
        title:
          "Front Collision - Avoidance Assist - Junction Turning (FCA - JT)",
        description:
          "Helps prevent accidents at intersections by assisting with braking.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fintu5.mp4?alt=media&token=05ac8c4a-e01f-4fac-b49c-f2170aef40e0",
      },
      {
        title: "Lane Keep Assist (LKA)",
        description:
          "Keeps you within your lane by providing steering assistance.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fintu6.mp4?alt=media&token=99094e05-775d-42b3-98c3-5a922290c05f",
      },
      {
        title: "High Beam Assist (HBA)",
        description:
          "Automatically switches between high and low beams for better visibility.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fintu7.mp4?alt=media&token=22032c69-b813-4d97-bd11-a554027d360e",
      },
      {
        title: "360 Degree Camera",
        description: "Offers a full view around the car to assist in parking.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fintu8.mp4?alt=media&token=bf9d64cd-e74d-428a-81d4-237a6067c6ad",
      },
      {
        title: "Parking Collision Avoidance Assist – Reverse (PCA-R)",
        description:
          "Brakes automatically when reversing if an obstacle is detected.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fintu9.mp4?alt=media&token=6bafd68c-db7e-4400-bbce-d4255cf7b9cc",
      },
    ],
  },
  {
    sub: "FUTURISTIC CONNECTED CAR TECHNOLOGY",
    title: "Kia Connect 2.0",
    data: "Embrace the future with Kia Connect 2.0. Over 80+ Kia Connect features bring you closer to your Syros, giving you seamless control and an evolved driving experience.",
    carData: [
      {
        title: "Over-the-air (OTA) Software Updates",
        description: "Stay updated with seamless over-the-air updates.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2FFut-1.mp4?alt=media&token=2c7e30d9-8703-4cf5-b237-1acdb855e9fc",
      },
      {
        title: "76.2cm (30”) Trinity Panoramic Display panel",
        description:
          "Best-in-segment display that brings navigation and connectivity to your fingertips.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2FFut-2.mp4?alt=media&token=79c21c48-5683-4929-9f5f-937f135aa6e7",
      },
      {
        title: "Kia Remote Diagnostics",
        description:
          "Remotely diagnose and resolve issues with Kia's service team.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2FFut-3.webp?alt=media&token=5bd66631-54aa-49ac-afb9-d38e36e0a2c2",
      },
      {
        title: "Wake-up Command",
        description:
          "With one command, your car comes to life, ready to take you places.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2FFut-4.webp?alt=media&token=3723c597-07ea-4ab3-9ddb-99bc4396c091",
      },
      {
        title: "Multilingual VR Commands",
        description:
          "Navigate seamlessly with voice commands in multiple languages.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2FFut-5.webp?alt=media&token=ca9ab3fb-aa5d-4f7c-bcf6-86ae7f9f593c",
      },
      {
        title: "Call Center Assisted Navigation",
        description:
          "Connect instantly with our call center for on-the-spot navigation assistance.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2FFut-6.webp?alt=media&token=327d58cb-61b2-496b-8ee5-f641f988a94a",
      },
    ],
  },
  {
    sub: "EVOLVE YOUR DRIVE",
    title: "Accessories designed for a new species of SUV.",
    data: "The future of SUVs is here, and now you can make it truly yours. Customize your Syros with exclusive accessories that bring innovation and sophistication together.",
    carData: [
      {
        title: "The Kia Syros Robust-A Package",
        description:
          "Built for those who crave adventure, this package enhances durability and resilience, ensuring your Syros is ready for every challenge ahead.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fwe_1.mp4?alt=media&token=20b5899c-8355-4916-b5e6-1986bcb7390d",
      },
      {
        title: "The Kia Syros Robust-B Package",
        description:
          "Designed to reinforce the commanding presence of your Syros, this package adds toughness and refinement, making every drive feel unstoppable.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fwe_2.mp4?alt=media&token=799f8cb5-10e9-4bc0-af78-6b43fe8d8567",
      },
      {
        title: "The Kia Syros Luxe Package",
        description:
          "Premium design meets innovation in this package, enhancing comfort, sophistication, and cutting-edge convenience for a truly evolved driving experience.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fwe_3.mp4?alt=media&token=4d9ee31d-353c-4255-979a-d9ebc2e2381c",
      },
    ],
  },
];

const TrimData = [
  {
    title: "HTK",
    cost: "8,67,053",
    feature1: "Standard 20 Hi Safety Package",
    feature2: "Streamline Door Handles",
    feature3:
      "30.48 cm (12”) Full Segment LCD Cluster with Advanced 10.5 cm (4.2”) Color TFT MID",
    feature4: "Manual Air conditioner and Rear AC Vents",
    feature5: "Kia Signature Digital Tiger Face",
    feature6: "Rear Door Sunshade Curtains",
    feature7: "Double D-Cut Steering Wheel",
  },
  {
    title: "HTK(0)",
    cost: "9,39,109",
    feature1: "Standard 20 Hi Safety Package",
    feature2: "Streamline Door Handles",
    feature3: "31.24 cm (12.3”) HD Touchscreen with 4 Speakers and 2 Tweeters",
    feature4: "Sunroof",
    feature5: "Bold Bridge Type Roof Rails",
    feature6: "Driver Seat Height Adjust",
    feature7: "R16 - 40.56 cm (16”) Crystal Cut Alloy Wheels (D1.5)",
  },
  {
    title: "HTK+",
    cost: "10,73,957",
    feature1: "Streamline Door Handles",
    feature2: "31.24 cm (12.3”) HD Touchscreen with 4 Speakers and 2 Tweeters",
    feature3: "Dual Pane Panoramic Sunroof",
    feature4: "R16 - 40.56 cm (16”) Crystal Cut Alloy Wheels",
    feature5: "60:40 Split Rear Seats with Sliding and Reclining Function",
    feature6: "Electric Parking Brake with Auto Hold (G1.0T 7DCT only)",
    feature7: "Smart Key with Push Button Start (G1.0T 7DCT only)",
  },
  {
    title: "HTX",
    cost: "12,10,484",
    feature1: "31.24 cm (12.3”) HD Touchscreen with 4 Speakers and 2 Tweeters",
    feature2: "Ice Cube MFR LED Headlamps",
    feature3: "Starmap LED DRL with integrated turn signal",
    feature4: "Starmap LED Combination Tail Lamps",
    feature5: "60:40 Split Rear Seats with Sliding and Reclining Function",
    feature6: "Front Ventilated Seats",
    feature7: "Leatherette seats",
  },
  {
    title: "HTX+",
    cost: "14,56,233",
    feature1: "Dual Pane Panoramic Sunroof",
    feature2:
      "60:40 Split Rear Seats with Sliding, Reclining and Ventilation (Seat only) Function",
    feature3: "Trinity Panoramic Display",
    feature4: "Kia Connect 2.0",
    feature5: "OTA Software Updates with Kia Remote Diagnostics",
    feature6: "Harman Kardon Premium 8 Speakers Sound System",
    feature7:
      "Note: ADAS Pack available at additional Rs 80K only on the top end trim",
  },
];

const CircleData = [
  {
    title: "Frost Blue",
    color: "#456274",
    imgSrc: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Ffrost%20blue.webp?alt=media&token=8c20af80-cb0a-4e95-8224-3849d18b7c5a",
  },
  {
    title: "Sparkling Silver",
    color: "#e0e0df",
    imgSrc: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fsilver.webp?alt=media&token=f28a6d44-dc19-46d5-8447-457adcfff6b2",
  },
  {
    title: "Gravity Grey",
    color: "#444444",
    imgSrc: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fgravity%20gary.avif?alt=media&token=4e312ee6-b9a6-4a11-987a-af32995b9962",
  },
  {
    title: "Imperial Blue",
    color: "#2b2c71",
    imgSrc: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fi%20blue.webp?alt=media&token=f45ec1ac-8b76-4e6f-8356-ecb6463bbab1",
  },
  {
    title: "Intense Red",
    color: "#b2001e",
    imgSrc: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fr%20red.avif?alt=media&token=f5352253-e28b-40ed-9f16-cba68bf8a6d0"
  },
  {
    title: "Pewter Olive",
    color: "#3e493b",
    imgSrc: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fp%20olive.webp?alt=media&token=46813fd3-91c4-4f18-919a-b9382fba508a"
  },
  {
    title: "Glacier White Pearl",
    color: "#f3f9fb",
    imgSrc: 'https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fg%20white.webp?alt=media&token=8de25f9f-02e0-448b-abcb-949d8881dbfa'
  },
  {
    title: "Aurora Black Pearl",
    color: "#151617",
    imgSrc: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fa%20black.webp?alt=media&token=656c99e9-c777-4418-b332-63373147cbd4"
  },
];

const DetailInfo = [
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Bring home the Kia Syros",
    desc: "Experience an evolution by the future",
    link: "",
  },
  {
    bgColor: "#05141f",
    color: "#FFF",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/download.png?alt=media&token=9de03b22-8ba2-433e-9ff0-a78165faaf3a",
    title: "Download Brochure",
    desc: "Know it all about the new species of SUV",
    link: "https://www.kia.com/content/dam/kia2/in/en/our-vehicles/syros/Kia_Syros_2025_Desktop.pdf",
  },
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Call us for more information",
    desc: "We'll be happy to answer all your queries. 1800 108 5000",
    link: "",
  },
];

const FaqData = [
  {
    question: "What is the new price of the Kia Syros after GST cut?",
    answer:
      "Kia Syros starts at price of ₹ 8 67 053*(Ex-showroom price all India) after GST cut.",
  },
  {
    question: "How many features does the Kia Syros offer in its ADAS system?",
    answer:
      "The Kia Syros offers Robust 20 standard safety pack and intuitive features in its ADAS system. With ADAS Level 2.0 technology, you can experience cutting-edge safety and convenience features that bring the future to your present.",
  },
  {
    question: "How many airbags are there in the Kia Syros?",
    answer:
      "The Kia Syros comes equipped with 6 airbags as standard, ensuring enhanced safety for both the driver and passengers.",
  },
  {
    question: "Does the Kia Syros come with a sunroof?",
    answer:
      "The Kia Syros SUV comes with Dual Pane Panoramic Sunroof with a view that bridges the present and the possibilities ahead.",
  },
  {
    question: "What are Kia Syros engine options?",
    answer:
      "There are two options for Kia Syros- D1.5 CRDi VGT Diesel and G1.0 T-GDi Petrol Engine",
  },
];

const StepData = [
  {
    title: "Starmap LED DRLs",
    desc: "Command attention, no matter where the road takes you.",
  },
  {
    title: "Ice Cube MFR LED Headlamps",
    desc: "Illuminate the road ahead with cutting-edge precision, bringing tomorrow's tech to your drive. ",
  },
  {
    title: "Streamline Door Handles",
    desc: "A sleek silhouette that enhances the car’s aerodynamic profile and takes design beyond the ordinary.",
  },
  {
    title: "Starmap LED Tail Lamps",
    desc: "Shine brighter, stand bolder—these lights guide the way to a future filled with innovation and style. ",
  },
  {
    title: "Dual Pane Panoramic Sunroof",
    desc: "Open up to the future and enjoy unobstructed views that stretch as far as your imagination. ",
  },
  {
    title: "76.2cm (30`) Trinity Panoramic Display panel",
    desc: "12.3” HD Touchscreen + 30.48 cm (12”) LCD Cluster + 5” Fully Automatic Air Conditioner Control – The future of in-car control and comfort. ",
  },
];

export {
  CarouselData,
  TrimData,
  CircleData,
  DetailInfo,
  FaqData,
  StepData,
  BannerData,
  IntroData
};
